const logged = {
  login: () => ({ type: "LOG_IN" }),
  logout: () => ({ type: "LOG_OUT" }),
  isLoggingOut : (logging_out) => ({ type : "LOGGING_OUT", payload: logging_out }),
  profile: (userProfile) => ({ type: "SET_PROFILE", payload: userProfile }),
};

export default logged;
